import Layout from '../components/Layout'
import { PageHeader, Section, Card } from '../components/UIComponents'

export default function Receive() {
  const walletAddress = '0x1234...5678'

  return (
    <Layout>
      <div className="space-y-8 max-w-4xl mx-auto">
        <PageHeader
          icon="📥"
          title="Recibir Fondos"
          description="Comparte tu dirección o código QR para recibir pagos"
        />

        <Section title="Tu Dirección de Cartera">
          <Card>
            <div className="space-y-4">
              <div className="p-4 bg-slate-800 rounded-lg border border-slate-700 text-center">
                <p className="text-slate-400 text-sm mb-2">Tu dirección de cartera</p>
                <p className="text-white font-mono text-lg break-all">{walletAddress}</p>
              </div>
              <button className="w-full px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white font-semibold rounded-lg transition-colors">
                Copiar Dirección
              </button>
            </div>
          </Card>
        </Section>

        <Section title="Código QR">
          <Card>
            <div className="flex flex-col items-center gap-4">
              <div className="w-48 h-48 bg-slate-800 rounded-lg border-2 border-slate-700 flex items-center justify-center">
                <span className="text-slate-600 text-4xl">📱</span>
              </div>
              <button className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white font-semibold rounded-lg transition-colors">
                Descargar QR
              </button>
            </div>
          </Card>
        </Section>
      </div>
    </Layout>
  )
}
